import { SsoType } from '../../sharedTypes';

type EnvironmentSpecificConfig = {
  API_URL: string;
  APP_URL: string;
};

const dev: EnvironmentSpecificConfig = {
  API_URL: 'http://localhost:8088/dev',
  APP_URL: 'https://dev.lwm.haufe-akademie.de/',
};
const test: EnvironmentSpecificConfig = {
  API_URL: 'https://k9t746hyw7-vpce-05230a3b44834b6c7.execute-api.eu-central-1.amazonaws.com/test',
  APP_URL: 'https://test.lwm.haufe-akademie.de/',
};

const prod: EnvironmentSpecificConfig = {
  API_URL: 'https://qg2ljhfu2l-vpce-029a257f23c61e79f.execute-api.eu-central-1.amazonaws.com/prod',
  APP_URL: 'https://manager.lernwelt.haufe-akademie.de/',
};

const env = process.env.REACT_APP_STAGE || 'dev';

const config = env === 'test' ? test : env === 'prod' ? prod : dev;

const mergedConfig = {
  ...config,
  STANDALONE: env === 'dev',
};

export const AvailableSsoTypes: readonly SsoType[] = ['sso', 'ssoWithUserDataComparison'];

export const MICROFRONTEND_ID = 'lwmSettings';

export default mergedConfig;
